import React from 'react';
import Facebook from '../../../images/facebook.png';
import Youtube from '../../../images/youtube.png';
import Insta from '../../../images/insta.png';
import Spotify from '../../../images/spotify.png';
import { Link } from 'react-router-dom';

const MainFooter = () => {
  return (
    <footer>
      <div>
        <div>
          <div>
            <h3 className='footer_heading-style'>Submit</h3>
            <p className='footer_para-style'>your music</p>
          </div>
          <div>
            <p>Release your music on our label</p>
            <Link to='#'>evidence@musichighcourt.com</Link>
          </div>
          <div className='socialmedia_icons'>
            <span>
              <img src={Spotify} alt='' />
            </span>
            <span>
              <img src={Youtube} alt='' />
            </span>
            <span>
              <img src={Insta} alt='' />
            </span>
            <span>
              <img src={Facebook} alt='' />
            </span>
          </div>
        </div>
        <div>
          <div>
            <h4>Hear from us</h4>
          </div>
          <div>
            <p>Subscribe to our newsletter and receive the latest updates</p>
          </div>
          <div className='divider'></div>
          <div>
            <button className='btn btn-black'>Subscribe</button>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default MainFooter;
